import React from "react";
import { ButtonGroup } from "@mui/material";

import useWindowDimensions from "../hooks/useWindowDimensions";
import FilterButton from "./filterButton";
import { ERPType, FilterType } from "../types/types";
import useTheme from "../hooks/useTheme";

export default function ERPFilterButtons(props: {
  filter: FilterType;
  onChange: (filter: FilterType) => void;
  style?: React.CSSProperties;
}) {
  const { isSmallLayout } = useWindowDimensions();

  const theme = useTheme();
  const ergoImage: string = theme.images.ergo;
  const radixImage: string = theme.images.radix;

  const styles: {
    ergoFilter: React.CSSProperties;
    radixFilter: React.CSSProperties;
  } = {
    ergoFilter: {
      height: isSmallLayout ? 20 : 35,
      width: isSmallLayout ? 45 : 80,
    },
    radixFilter: {
      height: isSmallLayout ? 25 : 40,
      width: isSmallLayout ? 45 : 80,
      marginLeft: isSmallLayout ? 2 : 5,
    },
  };

  return (
    <div style={props.style}>
      <ButtonGroup
        variant="contained"
        aria-label="outlined primary button group"
      >
        <FilterButton
          onChange={() =>
            props.onChange({
              erp: ERPType.ergo,
              platform: props.filter.platform,
            })
          }
          selected={props.filter.erp === ERPType.ergo}
          imageSrc={ergoImage}
          imageStyle={styles.ergoFilter}
        />

        <FilterButton
          onChange={() =>
            props.onChange({
              erp: ERPType.radix,
              platform: props.filter.platform,
            })
          }
          selected={props.filter.erp === ERPType.radix}
          imageSrc={radixImage}
          imageStyle={styles.radixFilter}
        />
      </ButtonGroup>
    </div>
  );
}
